/**
 * Procedure Categories and Procedures for MS in Traumatology & Surgery students
 * Extracted with strict evidence from official NMC PDF (Page 6-9: "Resuscitative procedures", "Major Operative procedures", and "Procedural Skills Table")
 */
export const TRAUMATOLOGY_PROCEDURES = {
  "Trauma Resuscitation & Emergency Airway Procedures": [
    "Airway Management, Endotracheal Intubation & Rapid Sequence Induction (RSI)",
    "Surgical Airway (Cricothyroidotomy & Open/Percutaneous Tracheostomy)",
    "Venous Access, Intraosseous Access & Venous Cut Down",
    "Needle Thoracocentesis, Chest Drain Insertion & Pericardial Drainage",
    "Focussed Assessment Sonography in Trauma (FAST) & Diagnostic Peritoneal Lavage (DPL)",
    "Control of Oromaxillofacial & Nasal Bleeding (Anterior/Posterior Nasal & Oral Packing)",
    "Resuscitation, Ventilatory Support & Massive Transfusion Protocols",
    "Decontamination, Gastric Lavage & Damage Control Resuscitation",
  ],
  "Emergency Operative Trauma & Visceral Surgical Procedures": [
    "Emergency Laparotomy for Trauma & Acute Abdomen (Perforation, Obstruction, Ischaemia)",
    "Emergency Thoracotomy & Management of Chest / Cardiac / Diaphragmatic Injuries",
    "Emergency Craniotomy & Cranial Decompression for Head Trauma",
    "Exposure & Emergency Management of Gastric, Small Intestine, Colon & Duodenal Injuries",
    "Emergency Management of Liver, Splenic, Pancreatic & Rectal Injuries",
    "Emergency Management of Renal, Ureteral & Bladder Injuries",
    "Emergency Vascular Procedures, Acute Thrombo-Embolectomy & Limb Salvage Shunts",
    "Open & Percutaneous Gastrostomy & Jejunostomy",
  ],
  "Orthopaedic Trauma, Wound & Reconstruction Procedures": [
    "Splinting of Fractures, Traction Application (Femoral/Tibial) & Pelvic Stabilization",
    "Reduction of Dislocations & Amputations at Various Levels",
    "Fasciotomy for Upper & Lower Extremity Compartment Syndrome",
    "Radical Soft Tissue Debridement for Necrotizing Infections & Crush Injuries",
    "Split Thickness & Full Thickness Skin Grafting",
    "Basic Plastic Procedures for Soft Tissue Reconstruction & Coverage",
    "Intermaxillary Wiring & Facial Fracture Management",
    "Surgical Control of Upper/Lower GI Bleed, Acute Scrotum & Emergency Caesarean Section",
  ],
};

export const TRAUMATOLOGY_CATEGORIES = Object.keys(TRAUMATOLOGY_PROCEDURES);

export const isMSInTraumatologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("traumatology") ||
    d.includes("trauma") ||
    d.includes("acute care surgery")
  );
};
